export default [{
        path: '/system-category-groups',
        name: 'cagtegoryGroups',
        meta: { title: 'nav.categoryGroup' },
        component: () =>
            import ('@/components/page/system/categoryGroupList'),
    }, {
        path: '/category-leaders',
        name: 'cagtegoryLeaders',
        meta: { title: 'nav.categoryGroup' },
        component: () =>
            import ('@/components/page/system/materialCategoryLeaderList'),
    },
    {
        path: '/system-msv-groups',
        name: 'msvGroups',
        meta: { title: 'nav.MSVGroup' },
        component: () =>
            import ('@/components/page/system/msvGroupList'),
    },
    {
        path: '/backgroundProcessLog',
        name: 'apiLog',
        meta: { title: 'nav.backgroundProcessLog' },
        component: () =>
            import ('@/components/page/system/apiLog'),
    },
    {
        path: '/crons',
        name: 'crons',
        meta: { title: 'nav.Cron' },
        component: () =>
            import ('@/components/page/system/cron'),
    },
    {
        path: '/post',
        name: 'post',
        meta: { title: 'nav.post' },
        component: () =>
            import ('@/components/page/system/post'),
    }
];